import { render, staticRenderFns } from "./TableRules.vue?vue&type=template&id=a26cd5a4&scoped=true&"
import script from "./TableRules.vue?vue&type=script&lang=js&"
export * from "./TableRules.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a26cd5a4",
  null
  
)

export default component.exports